export default __webpack_public_path__ + "static/media/image50.96c0ee72.svg";